import ReactDOM from 'react-dom';
import preloaded from '../src/preloaded.js';
import SupportRequestForm from '../src/supportRequests/SupportRequestForm.js';

ReactDOM.render(
  <SupportRequestForm
    url={preloaded.href}
    returnTo={preloaded.return_to}
    showUrl={true}
  />
, document.getElementById('app'));
